<script>
  import Button from "./Button.svelte";

  let showBanner = localStorage.getItem("showCookieBanner") !== "false";

  const hideCookieBanner = () => {
    localStorage.setItem("showCookieBanner", "false");
    showBanner = false;
  };
</script>

<style>
  .banner {
    background: #222729;
    color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.75rem 1.5rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a {
    color: inherit;
  }

  p {
    margin: 0;
  }
</style>

{#if showBanner}
  <div class="banner">
    <p>
      Denna webbplats använder cookies. Genom att fortsätta surfa så godkänner
      du Vänsterpartiets
      <a href="https://www.vansterpartiet.se/cookies/" target="_blank">
        cookie
      </a>
      och
      <a
        href="https://www.vansterpartiet.se/integritetspolicy/"
        target="_blank">
        integritetspolicy
      </a>
      .
    </p>
    <Button
      on:click={hideCookieBanner}
      style="padding-top: 0.375rem; padding-bottom: 0.375rem;">
      Ok
    </Button>
  </div>
{/if}
